import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { of } from "rxjs";
import { debounceTime, first, map, switchMap } from 'rxjs/operators';
import { RegisterService } from "src/app/services/register/register.service";
import { unmaskCnpj } from "../cnpj/cnpj";


export function isAvailable(registerService: RegisterService): AsyncValidatorFn {
    return (control: AbstractControl) => {
        if (!control.valueChanges || control.pristine) {
            return of(null);
        }
        else {
            return control.valueChanges.pipe(debounceTime(600)).pipe(switchMap(document =>
                registerService.documentExists(unmaskCnpj(document))))
                .pipe(map(utilizado => utilizado ? { 'document-already-used': true } : null))
                .pipe(first());
        }
    }
}

